import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// dockview base styles FIRST so our tokens.css overrides win the
// cascade for shared selectors like .dockview-theme-light.
import 'dockview-react/dist/styles/dockview.css';
import '@hc/ui/tokens.css';
import './i18n/index.js';
import { App } from './App.js';
import { AuthProvider } from './auth-provider.js';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </StrictMode>,
);
